import { Suspense } from 'react'
import { Route, Routes, useParams } from 'react-router'
import { useBackgroundQuery, useIdCompany } from '@/lib/hooks'
import { WebhookPageFallback } from '@/routes/webhook/fallback'
import { WEBHOOK_QUERY } from '@/routes/webhook/queries'
import { RBACCheck } from '@/routes/webhook/rbac-check'
import { EventDeliveriesTab } from '@/routes/webhook/tabs/event-deliveries'
import { OverviewTab } from '@/routes/webhook/tabs/overview'
import type {
  WebhookQuery,
  WebhookQueryVariables,
} from '@/routes/webhook/queries.types.gen'

export const WebhookPage = () => {
  const { idWebhook = '' } = useParams()
  const { idCompany } = useIdCompany()
  const [queryRef] = useBackgroundQuery<WebhookQuery, WebhookQueryVariables>(
    WEBHOOK_QUERY,
    { variables: { idCompany, idWebhook } }
  )

  return (
    <Routes>
      <Route
        element={
          <Suspense key={idWebhook} fallback={<WebhookPageFallback />}>
            <RBACCheck queryRef={queryRef} />
          </Suspense>
        }
      >
        <Route path="/overview/*" element={<OverviewTab />} />
        <Route path="/event-deliveries/*" element={<EventDeliveriesTab />} />
      </Route>
    </Routes>
  )
}
